import React from "react";
import { formatDistanceToNow } from "date-fns";

const getNotificationIcon = (type) => {
  switch (type) {
    case "USER_REGISTRATION":
      return "👤";
    case "PLAYER_REGISTRATION":
      return "⚾";
    case "PLAYER_LOGIN_CLAIM":
      return "🔐";
    case "VIDEO_REQUEST":
      return "🎥";
    default:
      return "📢";
  }
};

const NotificationItem = ({ notification, onMarkAsRead }) => {
  const timeAgo = notification.createdAt
    ? formatDistanceToNow(new Date(notification.createdAt), { addSuffix: true })
    : "";

  return (
    <div
      className={`p-3 rounded-lg border transition-colors ${
        notification.isRead
          ? "bg-jp-card border-jp-line"
          : "bg-jp-section border-sky-500/30"
      }`}
    >
      <div className="flex items-start gap-3">
        <div className="text-2xl flex-shrink-0">
          {getNotificationIcon(notification.type)}
        </div>
        <div className="flex-1 min-w-0">
          <div className="flex items-start justify-between gap-2 mb-1">
            <h4 className="text-xs font-semibold text-jp-ink">
              {notification.title}
            </h4>
            {!notification.isRead && (
              <div className="w-2 h-2 bg-sky-500 rounded-full flex-shrink-0 mt-1"></div>
            )}
          </div>
          <p className="text-xs text-jp-muted mb-2">{notification.message}</p>
          <div className="flex items-center justify-between">
            <span className="text-[10px] text-jp-muted">{timeAgo}</span>
            {!notification.isRead && (
              <button
                onClick={() => onMarkAsRead(notification._id)}
                className="text-[10px] text-jp-accent-ink hover:text-jp-accent transition-colors"
              >
                Mark as read
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export const NotificationList = ({
  notifications,
  loading,
  unreadCount,
  onMarkAsRead,
  onMarkAllAsRead,
  onLoadMore,
  hasMore,
}) => {
  return (
    <div className="rounded-2xl border border-jp-line bg-jp-card p-5 flex flex-col gap-4">
      {/* Header */}
      <div className="flex items-center justify-between flex-shrink-0">
        <div className="flex items-center gap-2">
          <h3 className="text-xs font-semibold text-jp-ink">NOTIFICATIONS</h3>
          {unreadCount > 0 && (
            <span className="px-2 py-0.5 rounded-full bg-sky-500 text-white text-[10px] font-bold">
              {unreadCount}
            </span>
          )}
        </div>
        {unreadCount > 0 && (
          <button
            onClick={onMarkAllAsRead}
            className="text-[10px] text-jp-accent-ink hover:text-jp-accent transition-colors"
          >
            Mark all as read
          </button>
        )}
      </div>

      {/* Notifications List */}
      <div className="overflow-y-auto custom-scrollbar space-y-2" style={{ maxHeight: '600px', minHeight: '400px' }}>
        {loading && notifications.length === 0 ? (
          <div className="flex items-center justify-center py-12">
            <div className="w-8 h-8 border-4 border-cyan-500 border-t-transparent rounded-full animate-spin"></div>
          </div>
        ) : notifications.length === 0 ? (
          <div className="flex flex-col items-center justify-center py-12 text-center">
            <div className="text-4xl mb-2">📭</div>
            <p className="text-xs text-jp-muted">No notifications yet</p>
          </div>
        ) : (
          <>
            {notifications.map((notification) => (
              <NotificationItem
                key={notification._id}
                notification={notification}
                onMarkAsRead={onMarkAsRead}
              />
            ))}
            {loading && (
              <div className="flex items-center justify-center py-4">
                <div className="w-5 h-5 border-2 border-cyan-500 border-t-transparent rounded-full animate-spin"></div>
              </div>
            )}
          </>
        )}
      </div>

      {/* Load More Button */}
      {hasMore && !loading && (
        <div className="flex-shrink-0 pt-2">
          <button
            onClick={onLoadMore}
            className="w-full py-2 text-xs bg-jp-section hover:bg-jp-line text-jp-ink rounded-lg transition-colors border border-jp-line"
          >
            Load More
          </button>
        </div>
      )}
    </div>
  );
};
